import { Box, styled, Typography } from "@mui/material";

export const StyledInvitationCard = styled("div")(({ theme }) => ({
  backgroundColor: "#fff",
  borderRadius: theme.borderRadius.radius.regular,
  padding: "20px",
  boxShadow: "0px 2px 8px rgba(0,0,0,0.1)",
}));

export const StyledHeader = styled("div")(({ theme }) => ({
  marginBottom: theme.spacing(2),
}));

export const StyledTitleContainer = styled(Box)(({theme})=>({
    display: "flex",
    alignItems: "center",
    gap: "12px",
    
}));

export const StyledTitle = styled(Typography)(({ theme, istest }) => ({
    fontSize: theme.typography.base.fontSize,
    fontWeight: theme.typography.fontWeight.bold,
    textAlign: "center",
    color: theme.palette.custom.orderName,
  }));

  export const StyledText = styled(Box)(({ theme, istest }) => ({
    display:"flex",
    flexDirection:"row",
    justifyContent:"start",
    flexWrap:"wrap",
    alignItems:"center",
    fontSize: theme.typography.regular.fontSize,
    fontWeight: theme.typography.fontWeight.thin,
    textAlign: "center",
    
    gap: theme.spacing(1),
    [theme.breakpoints.down("sm")]: {
      fontSize: theme.typography.small.fontSize,
    },
  }));

  export const StyledSpan = styled(Typography)(({ theme, istest }) => ({
    fontSize: theme.typography.regular.fontSize,
    fontWeight: theme.typography.fontWeight.bold,
    [theme.breakpoints.down("sm")]: {
      fontSize: theme.typography.small.fontSize,
    },
  }));

export const StyledIcon = styled("img")({
    width: "22px",
    height: "22px",
});

export const StyledItemList = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  maxHeight: "150px",
  overflowY: "auto",
  gap:  "4px",
}));

export const StyledItem = styled("div")(({ theme,selected }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: "12px 16px",
  backgroundColor: theme.palette.custom.assistBgColor,
  color: theme.palette.custom.orderName,
  [theme.breakpoints.down("sm")]: {
    padding: "8px 12px",
    flexDirection:"column",
    gap:theme.spacing(2),
  },
  borderRadius: theme.borderRadius.radius.wallet,
}));

export const StyledButtons = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection:"row",
  
  gap: theme.spacing(1),
}));
